"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackDelta = exports.trackSingleTime = exports.isInSample = void 0;
const tracking_1 = __importDefault(require("../tracking"));
const env_1 = require("../env");
const getConsistentRandomNumber_1 = __importDefault(require("../getConsistentRandomNumber"));
const tracker = (0, tracking_1.default)({ event: 'browser-client-timings', sendToDW: true, pushToDataLayer: false });
const SAMPLE_LEVEL = 0.005;
function isInSample(sampleSize) {
    if ((0, env_1.isDebug)()) {
        return true;
    }
    const sampleLevel = sampleSize ?? SAMPLE_LEVEL;
    return (0, getConsistentRandomNumber_1.default)() <= sampleLevel;
}
exports.isInSample = isInSample;
// TODO Change this to fandom context and support all different apps
function getAppName() {
    if (typeof window !== 'undefined' && typeof window.mw !== 'undefined') {
        return 'ucp';
    }
    return 'video-platform';
}
function trackSingleTime(eventName, time, options) {
    if (!isInSample(options?.sampleRate ?? undefined)) {
        return;
    }
    tracker({
        ...(options?.additionProps ?? {}),
        category: `timings-event-${eventName}`,
        label: getAppName(),
        action: 'timed',
        value: time,
    });
}
exports.trackSingleTime = trackSingleTime;
function trackDelta(eventOne, eventTwo, delta, options) {
    if (!isInSample(options?.sampleRate ?? undefined)) {
        return;
    }
    tracker({
        ...(options?.additionProps ?? {}),
        category: `timings-event-${eventOne}-to-${eventTwo}`,
        label: getAppName(),
        action: 'timed',
        value: delta,
    });
}
exports.trackDelta = trackDelta;
